import { useState } from "react"
import { Modal, Form, Input, Select, Option, Button } from "antd"
import { MinusCircleOutlined } from "@ant-design/icons"
import { POSITIONS, mapPosition } from "../../../utils/mappers"
import { useTranslation } from "react-i18next"
import { useUser } from "../../../contexts/UserContext"


const CreateOrUpdateProgram = ({ program = null, onSave, onCancel, isEditing }) => {
    const { t } = useTranslation()

    const EMPTY_PROGRAM = { programName: "", positions: [{ positionID: 0, timespan: 0 }], id: 255, interval:32, hourOfDay: 2 }
    const { remoteProps } = useUser()
    const [activeProgram, setActiveProgram] = useState(program ?? EMPTY_PROGRAM)
    const ignoredPositions = ["INTERMEDIATE", "BRINE_UP", ...(remoteProps.ValveSize == 2 ? [] : ["RINSE_2"])]
    const filteredPositions = POSITIONS.map((p, i) => ({ key: i, value: p }))
        .filter(({ value }) => !ignoredPositions.includes(value))
        .map(({ key, value }) => ({
            value: key,
            label: t(`general.filter.valve.position.ID_${value}`)
        }))

    const handleProgramModalOk = () => onSave(activeProgram)

    const handleProgramModalCancel = () => onCancel()

    const handleAddStep = () => {
        setActiveProgram({
            ...activeProgram,
            positions: [...activeProgram.positions, { positionID: 0, timespan: 0 }]
        })
    }

    const handleStepPositionChange = (e, index) => {
        const positions = activeProgram.positions.map((step, i) => (i === index ? { ...step, positionID: e } : step))
        setActiveProgram({ ...activeProgram, positions })
    }

    const handleStepTimeSpanChange = ({ currentTarget }, id) => {
        const { value } = currentTarget
        const positions = activeProgram.positions.map((step, i) => (i === id ? { ...step, timespan: +value } : step))
        setActiveProgram({ ...activeProgram, positions })
    }

    const handleRemoveStep = (stepIndex) => {
        if (stepIndex == 0)
        return
        const updatedSteps = activeProgram.positions.filter((_, i) => i !== stepIndex)
        setActiveProgram({ ...activeProgram, positions: updatedSteps })
    }

    const isValueValid = (v) => !v && v !== 0

    return (
        <Modal
            title={isEditing ? "Redigera Program" : "Nytt Program"}
            onOk={handleProgramModalOk}
            onCancel={handleProgramModalCancel}
            okText="Spara"
            cancelText="Avbryt"
            open
        >
            <Form layout="vertical">
                <Form.Item label="Namn">
                    <Input
                        placeholder="Untitled"
                        defaultValue={activeProgram?.programName ?? ""}
                        onChange={({ currentTarget }) => setActiveProgram({ ...activeProgram, programName: currentTarget.value })}
                    />
                </Form.Item>
                {activeProgram.positions.map(({ positionID, timespan }, id) => (
                    <div key={id} style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                        <Form.Item
                            label="Läge"
                            style={{ flex: 1, marginRight: 10 }}
                            validateTrigger="onBlur"
                            validateStatus={isValueValid(positionID) && "error"}
                            help={isValueValid(positionID) && "Vänligen välj ett läge"}
                        >
                            {id == 0 ? (
                            <Select
                                defaultValue={
                                    positionID || positionID === 0 ? t(`general.filter.valve.position.${mapPosition(positionID)}`) : ""
                                }
                                options={filteredPositions}
                                disabled
                                />

                            ) : (
                                    <Select
                                        defaultValue={
                                            positionID || positionID === 0 ? t(`general.filter.valve.position.${mapPosition(positionID)}`) : ""
                                        }
                                        options={filteredPositions}
                                        onSelect={(e) => handleStepPositionChange(e, id)}
                                    />
                            )}
                        </Form.Item>
                        <Form.Item
                            label="Tidsintervall (min)"
                            style={{ flex: 1, marginRight: 10 }}
                            validateStatus={isValueValid(timespan) && "error"}
                            help={isValueValid(timespan) && "Vänligen ange tidsintervall"}
                        >
                            {id == 0 ? (
                            <Input
                                type="number"
                                defaultValue={timespan}
                                min={0}
                                max={9999}
                                disabled
                                />
                            ) : (
                                <Input
                                        type="number"
                                        defaultValue={timespan}
                                        onChange={(e) => handleStepTimeSpanChange(e, id)}
                                        min={0}
                                        max={9999}
                                />
                            ) }
                        </Form.Item>

                        {id == 0 ? (
                            <Button
                                icon={<MinusCircleOutlined />}
                                style={{ alignSelf: "center", marginTop: "9px" }}
                                type="text"
                                onClick={() => handleRemoveStep(id)}
                                danger
                                disabled
                            />
                        ) : (

                            <Button
                                icon={<MinusCircleOutlined />}
                                style={{ alignSelf: "center", marginTop: "9px" }}
                                type="text"
                                onClick={() => handleRemoveStep(id)}
                                danger
                            />
                        )}
                    </div>
                ))}
                <Button type="dashed" onClick={handleAddStep} style={{ width: "100%" }}>
                    Lägg till läge
                </Button>
            </Form>
        </Modal>
    )
}
export default CreateOrUpdateProgram
